import { createApi } from "@reduxjs/toolkit/query/react";
import { ENDPOINTS } from "config/constant/endpoints.config";
import { Paginator } from "types/interfaces";
import { injectParamsPaginator } from "utils/helpers/api-url";
import { baseQueryWithReauth } from "../rtkBaseQuery";

export const statisticsProductApi = createApi({
  reducerPath: "statisticsProductApi",
  baseQuery: baseQueryWithReauth,
  tagTypes: ["StatisticProduct"],
  endpoints: (builder) => ({
    getProductStatistics: builder.mutation({
      query: ({
        start_date,
        end_date
      }: {start_date?:number,end_date?:number}) => ({
        url: `/stats/products`,
        method: "POST",
        body:start_date && end_date? {  start_date,
            end_date,
           }:{},
      }),
      invalidatesTags: ["StatisticProduct"],
    }),
  })
})

export const { useGetProductStatisticsMutation} =statisticsProductApi;
